<template>
  <auth-layout>
    <div class="w-full md:w-4/5 mx-auto">
      <div
        class="auth-tab mt-8 flex justify-center text-xl font-semibold text-darkBlue"
      >
        <div
          :class="{ selected: currentTab == 'LoginForm' }"
          class="px-12 pb-2"
          @click="currentTab = 'LoginForm'"
        >
          <p>Login</p>
        </div>
        <div
          :class="{ selected: currentTab == 'SignupForm' }"
          class="px-12"
          @click="currentTab = 'SignupForm'"
        >
          <p>Signup</p>
        </div>
      </div>
      <keep-alive>
        <component :is="currentTab"></component>
      </keep-alive>
    </div>
  </auth-layout>
</template>

<script>
import AuthLayout from "../Authlayout/OnDemand";
import SignupForm from "./SignupForm.vue";
import LoginForm from "./LoginForm.vue";
export default {
  components: {
    AuthLayout,
    SignupForm,
    LoginForm,
  },
  data() {
    return {
      currentTab: "LoginForm",
    };
  },
  created(){
      let action = this.$route.query.action

      if(action == 'signup'){
          this.currentTab = "SignupForm"
      }
  }
};
</script>

<style scoped>
.auth-tab div {
  cursor: pointer;
  border-bottom: 2px solid #dae8f6;
}
.auth-tab div.selected {
  border-bottom: 2px solid var(--amber);
}
</style>
